<template>
  <div class="dialog-wrap">
    <el-dialog title="已购课程"
               :close-on-click-modal="false"
               :visible.sync="visible"
               @close="handleClose"
               width="960px">
      <div class="headers">
        <div>
          <el-form class="search-wrap"
                   ref="searchForm"
                   :inline="true"
                   :model="query">
            <!-- clearable -->
            <el-form-item label="课程类型"
                          prop="status">
              <el-select v-model="status"
                         placeholder="请选择"
                         @change="handleSearch">
                <el-option v-for="item in categorys"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <!-- <div>
                    <el-button type="primary" @click="search">搜索</el-button>
                    <el-button>重置</el-button>
                </div> -->
      </div>

      <el-table :cell-style="{'text-align':'center'}"
                :header-cell-style="{'text-align':'center'}"
                :data="tableData"
                border
                style="width: 100%"
                :header-row-style="{ textAlice: 'center' }">
        <el-table-column fixed
                         prop="id"
                         label="ID"
                         width="50">
        </el-table-column>
        <el-table-column prop="name"
                         label="课程名称"
                         width="350"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div style="text-align: left;">{{ scope.row.name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="province"
                         label="课程类型"
                         width="120">
          <template slot-scope="scope">
            {{ scope.row.type == 1 ? '在线课程' : scope.row.type == 3 ? '阅读资料' : '其他' }}
          </template>
        </el-table-column>
        <el-table-column prop="city"
                         label="状态"
                         width="80">
          <template slot-scope="scope">
            <el-tag v-if="status == 1"
                    :type="scope.row.user_course_delete == 0 ? 'success' : 'info'"> {{
                            scope.row.user_course_delete == 0 ? '有效' : '失效' }}</el-tag>
            <el-tag v-else-if="status == 3"
                    :type="scope.row.user_read_delete == 0 ? 'success' : 'info'"> {{
                            scope.row.user_read_delete == 0 ? '有效' : '失效' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="city"
                         label="有效期状态"
                         width="100">
          <template slot-scope="scope">
            <el-tag v-if="status == 1"
                    :type="scope.row.user_course_status == 1 ? 'success' : 'info'"> {{
                            scope.row.user_course_status == 1 ? '有效' : '失效' }}</el-tag>
            <el-tag v-else-if="status == 3"
                    :type="scope.row.user_read_status == 1 ? 'success' : 'info'"> {{
                            scope.row.user_read_status == 1 ? '有效' : '失效' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="address"
                         label="观看进度"
                         width="160">
          <template slot-scope="scope">
            <el-progress v-if="status == 1"
                         :text-inside="true"
                         :stroke-width="20"
                         :percentage="scope.row.user_course_learn_progress ? (scope.row.user_course_learn_progress * 100) : 0"></el-progress>
            <el-progress v-else-if="status == 3"
                         :text-inside="true"
                         :stroke-width="20"
                         :percentage="scope.row.user_read_learn_progress ? (scope.row.user_read_learn_progress * 100) : 0"></el-progress>
          </template>
        </el-table-column>
        <el-table-column prop="zip"
                         label="开课时间"
                         width="130">
          <template slot-scope="scope">
            <span v-if="status == 1">{{
                            scope.row.user_course_create_time ?
                            $moment(scope.row.user_course_create_time).format('YYYY.MM.DD HH: mm') : '暂无' }}</span>
            <span v-else-if="status == 3">{{
                            scope.row.user_read_create_time ? $moment(scope.row.user_read_create_time).format('YYYY.MM.DD HH:mm'):'暂无' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="zip"
                         label="到期时间"
                         width="130">
          <template slot-scope="scope">

            <span v-if="status == 1">{{ scope.row.user_course_expire_time
                            ? $moment(scope.row.user_course_expire_time).format('YYYY.MM.DD HH:mm') : '暂无' }}</span>
            <span v-else-if="status == 3">{{
                            scope.row.user_read_expire_time ? $moment(scope.row.user_read_expire_time).format('YYYY.MM.DD HH:mm'):'暂无' }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="70">
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       @click="handleUp(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑"
               :close-on-click-modal="false"
               :visible.sync="upVisible"
               @close="upVisible = false"
               width="360px">
      <el-form ref="ruleForm"
               :model="dataForm"
               label-width="90px">
        <el-form-item label="有效期状态">
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="1">有效</el-radio>
            <el-radio :label="0">失效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="课程状态">
          <el-radio-group v-model="dataForm._delete">
            <el-radio :label="0">有效</el-radio>
            <el-radio :label="1">失效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="到期时间">
          <el-date-picker :clearable="false"
                          v-model="dataForm.time"
                          type="datetime"
                          format="yyyy-MM-dd HH:mm"
                          placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="upVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="upSubmit('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { courseList, readList, memberCourse, memberRead } from '@/api/member'
import { getStorage } from '@/utils/helper'
export default {
  props: {
    uid: {
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      status: 1,
      dataForm: {
        time: '',
        _delete: '0',
        status: 1,
      },
      upVisible: false,
      query: {
        isPaging: 0,
        is_all_delete: 1,
        uid: '',
      },

      categorys: [
        {
          id: 1,
          name: '在线课程',
        },
        {
          id: 3,
          name: '阅读资料',
        },
      ],
      tableData: [],
      itemObj: {},
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 课程
        this.query.uid = this.uid
        if (this.status == 1) {
          this.getCourseList()
        } else {
          this.getReadList()
        }
      }
    },
    content(val) {
      this.dataForm = val
      if (val.category_ids) {
        this.dataForm.category_ids = val.category_ids
          .split(',')
          .map((v) => Number(v))
      }
    },
  },
  methods: {
    search() {
      if (this.status == 1) {
        this.getCourseList()
      } else {
        this.getReadList()
      }
    },
    getReadList() {
      readList(this.query).then((res) => {
        this.tableData = res.list
        console.log('cc2', res)
      })
    },
    getCourseList() {
      courseList(this.query).then((res) => {
        this.tableData = res.list
        console.log('cc', res)
      })
      // this.get
      // /member/course/list
      // this.fetchCategoryList()
    },
    upSubmit() {
      if (this.status == 1) {
        memberCourse({
          id: this.itemObj.user_course_id,
          _delete: this.dataForm._delete,
          status: this.dataForm.status,
          expire_time: new Date(this.dataForm.time).getTime(),
        }).then((res) => {
          this.getCourseList()
          this.upVisible = false
          console.log('res', res)
        })
      } else if (this.status == 3) {
        memberRead({
          id: this.itemObj.user_read_id,
          _delete: this.dataForm._delete,
          status: this.dataForm.status,
          expire_time: new Date(this.dataForm.time).getTime(),
        }).then((res) => {
          this.getReadList()
          this.upVisible = false
          // console.log("res", res)
        })
      }
    },
    handleUp(item) {
      if (this.status == 1) {
        this.dataForm._delete = item.user_course_delete
        this.dataForm.time = item.user_course_expire_time
        this.dataForm.status = item.user_course_status
      } else if (this.status == 3) {
        this.dataForm._delete = item.user_read_delete
        this.dataForm.time = item.user_read_expire_time
        this.dataForm.status = item.user_read_status
      }
      this.upVisible = true
      this.itemObj = item
      console.log('item', this.dataForm)
    },
    handleSearch() {
      if (this.status == 1) {
        this.getCourseList()
      } else {
        this.getReadList()
      }
      // this.$set(this.query, 'pageIndex', 1)
      // this.fetchMemberList()
    },
    handleSubmit() {
      this.$emit('close')
    },
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>
  
<style lang="less" scoped>
.headers {
  display: flex;
  justify-content: space-between;
}

.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
  